<script setup lang="ts">
const props = defineProps<{
  tooltip: {
    visible: boolean,
    x: number,
    y: number,
    time: string,
    value: string
  }
}>();
</script>
<template>
  <div
    class="py-1 px-2"
    :style="{
      position: 'absolute',
      top: `${props.tooltip.y}px`,
      left: `${props.tooltip.x}px`,
      background: 'rgb(0,0,0,0.7)',
      border: '1px solid rgb(0,0,0,0.6)',
      color: 'white',
      borderRadius: '8px',
      pointerEvents: 'none'
    }"
  >
    <div>
      <div><strong>{{ props.tooltip.time }}</strong></div>
      <div><strong>▫️{{ props.tooltip.value }}</strong></div>
    </div>
  </div>
</template>
